export default function WhatDoing() {
  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            年度管理方案在做什麼？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>
        
        <div className="bg-white rounded-2xl p-10 md:p-14 shadow-sm border border-gray-100">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
            年度管理方案不是<strong className="text-gray-900">「加價服務」</strong>，<br />
            而是讓 0 元一頁式網站可以持續存在的基礎。
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            我們會負責網站的代管、基本維運與必要調整，<br />
            讓網站可以真的被使用，<br />
            <strong className="text-teal-600">而不是做完後放著不動</strong>。
          </p>
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 md:p-10 border border-teal-100">
          <div className="flex items-start mb-6">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">持續服務的核心概念</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                我們不只是「做完交付」，而是在使用過程中持續支援，確保網站始終可以正常運作並符合實際需求。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
